import { Search, User } from 'lucide-react'
import { NotificationBell } from './NotificationBell'
import { useAuthStore } from '../store/auth'
import { useState } from 'react'

export default function Header() {
  const [searchFocused, setSearchFocused] = useState(false)
  const user = useAuthStore((s) => s.user)

  return (
    <header className="h-16 bg-white/70 backdrop-blur-xl border-b border-apple-gray-100 flex items-center justify-between px-6 sticky top-0 z-40">
      {/* Search */}
      <div className={"flex items-center bg-apple-gray-50 rounded-full px-4 py-2 transition-all duration-200 " + (searchFocused ? "ring-2 ring-apple-blue/20 w-96" : "w-80")}>
        <Search className="w-4 h-4 text-apple-gray-400 flex-shrink-0" />
        <input
          type="text"
          placeholder="搜索资产、工单、文档..."
          className="bg-transparent border-none outline-none text-sm ml-2 w-full placeholder:text-apple-gray-400"
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
        />
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-4">
        <NotificationBell />

        <div className="flex items-center gap-3 pl-4 border-l border-apple-gray-200">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium text-apple-gray-900">{user?.real_name || user?.email || '未登录'}</div>
            <div className="text-xs text-apple-gray-400">{user?.email || ''}</div>
          </div>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-apple-blue to-apple-purple flex items-center justify-center text-white text-sm font-medium">
            <User className="w-4 h-4" />
          </div>
        </div>
      </div>
    </header>
  )
}
